import { render } from "./index.vue?vue&type=template&id=55a33652&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=55a33652&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Front_yitoutiao-mobile_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a33652"]])

export default __exports__